var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99812 3.52859C7.99812 2.65543 6.95752 2.20165 6.31767 2.7958L0.96408 7.76699C0.538015 8.16262 0.538015 8.83694 0.96408 9.23258L6.31767 14.2038C6.95752 14.7979 7.99812 14.3441 7.99812 13.471V11.1682C10.6621 11.1943 12.0907 11.5372 12.9682 12.0702C13.8323 12.5952 14.2058 13.3272 14.7 14.3155C14.7691 14.4538 14.9242 14.5264 15.0747 14.4909C15.2252 14.4553 15.3315 14.321 15.3315 14.1664C15.3315 11.3762 14.9336 9.29603 13.7797 7.90697C12.613 6.50268 10.7427 5.88266 8.00645 5.83598C8.00376 5.83594 8.00104 5.83493 7.99877 5.83267L7.99812 5.83196V3.52859Z",
    fill: "url(#paint0_linear_10510_41424)",
    stroke: "url(#paint1_linear_10510_41424)",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10510_41424",
    x1: 22.6749,
    y1: 8.51321,
    x2: 10.9473,
    y2: -5.87249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B90E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10510_41424",
    x1: 22.6749,
    y1: 8.51321,
    x2: 10.9473,
    y2: -5.87249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B90E2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.3533429232bbd31cb547db1c3a2b20c8.svg";
export { ForwardRef as ReactComponent };